import { dataProps } from "@/models/data.model";

import { useGetUpcomingChallenge } from "./useGetUpcomingChallenge";
import { useGetOngoingChallenge } from "./useGetOngoingChallenge";
import { useRTLeaderboard } from "./useLeaderboard";
import { useWinnersData } from "./useWinnersData";

export const useData = () => {
  const ongoing = useGetOngoingChallenge();
  const upcoming = useGetUpcomingChallenge();
  const winners = useWinnersData();
  const leaderboard = useRTLeaderboard(ongoing.data?.slug || "");

  const data: dataProps = {
    leaderboard: {
      loading: leaderboard.loading,
      data: leaderboard.data,
      length: leaderboard.data.length,
      error: leaderboard.error,
    },

    winners: {
      loading: winners.loading,
      data: winners.data,
      error: winners.error,
    },

    challenge: {
      loading: ongoing.loading,
      data: ongoing.data,
      error: ongoing.error,
    },

    nextChallenges: {
      loading: upcoming.loading,
      data: upcoming.data,
      error: upcoming.error,
    },

    hasOngoing: !!ongoing?.data?.slug,
    hasUpcoming:
      !!upcoming.data && upcoming.data.length !== 0 && !ongoing.loading,
    isFinished:
      upcoming?.data?.length === 0 && !ongoing.data?.slug && !ongoing.loading,
    loading: upcoming.loading || ongoing.loading || leaderboard.loading,
  };

  return { data, loading: data.loading };
};
